import * as React from 'react';
import { IgcButtonComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Represents a clickable button, used to submit forms or anywhere in a
 * document for accessible, standard button functionality.
 *
 * The button supports multiple visual variants, can render as an anchor
 * (`<a>`) element when the `href` attribute is set, and is fully
 * form-associated, acting as a native `submit` or `reset` control.
 * @slot  - Renders the label of the button.
 * @slot prefix - Renders content before the label of the button.
 * @slot suffix - Renders content after the label of the button.
 * @csspart base - The native button element of the igc-button component.
 * @csspart prefix - The prefix container of the igc-button component.
 * @csspart suffix - The suffix container of the igc-button component.
 * @class
 */
export const IgrButton = /* @__PURE__ */ createComponent({
  tagName: 'igc-button',
  displayName: 'IgrButton',
  elementClass: Component,
  react: React,
});

export type IgrButton = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrButtonModule = Component;
